export default "__VITE_ASSET__DWvCq096__"